import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import ContactButton from '../ContactButton'
import ContentsButton from "../../images/contents_button.png"
import Pankuzu from '../pankuzu';
import PrivacyTop from "../../images/ProductTop.png";
import Product_01 from "../../images/Product_01.png";
import Product_02 from "../../images/Product_02.png";
import Product_03 from "../../images/Product_03.png";
import Product_04 from "../../images/Product_04.png";
import Product_05 from "../../images/Product_05.png";
import Product_06 from "../../images/Product_06.png";
import Product_07 from "../../images/Product_07.png";
import Product_08 from "../../images/Product_08.png";
import Product_09 from "../../images/Product_09.png";

// animation
import {motion} from "framer-motion"

const PageProduct = () => {
    return(
        <div id="PageKondou">  
            <div id="PageProduct">
                <KondoHeader />
                <motion.div
                    animate={{
                        y: 0,
                        opacity: 1
                    }}
                    initial={{
                        y: 0,
                        opacity: 1
                    }}
                    exit={{
                        y: 100,
                        opacity: 0
                    }}
                    transition={{
                        duration: 0.4,
                        ease: "easeOut",
                    }}
                >
                    <main>
                        <section className='product-top'>
                            <img src={PrivacyTop} alt='PRODUCTページのトップ' />
                            <Pankuzu pagename="商品紹介" />
                            <article>
                                <h1>PRODUCTS</h1>
                                <h2>商品紹介</h2>
                            </article>
                        </section>
                        <section className='product-article'>
                            <div>
                                <article>
                                    <h2>大漁旗</h2>
                                    <a href='http://www.kondo-some.co.jp/lineup/tairyou.html'>
                                        <img src={Product_01} alt='Product_01' />
                                    </a>
                                    <p>
                                        皆様からご支援を受け、【大漁旗の近藤】
                                        とその名が全国で呼ばれるようになりました。
                                        安全航海の魔除け、進水式の祝旗、大漁祈願
                                        は近藤染工場にぜひ御任せ下さい。
                                    </p>
                                    <a href='http://www.kondo-some.co.jp/lineup/tairyou.html'>
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>のれん/日除けのれん</h2>
                                    <a href='http://www.kondo-some.co.jp/lineup/noren.html'>
                                        <img src={Product_02} alt='Product_02' />
                                    </a>
                                    <p>
                                        お店の顔は暖簾。お客様が立ち寄りやすい粋な
                                        暖簾をお仕立ていたします。
                                        お店のイメージに似合うデザインやサイズ、生
                                        地などご相談ください。
                                    </p>
                                    <a href='http://www.kondo-some.co.jp/lineup/noren.html'>
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>はんてん/祭小物</h2>
                                    <a href='http://www.kondo-some.co.jp/lineup/hanten.html'>
                                        <img src={Product_03} alt='Product_03' />
                                    </a>
                                    <p>
                                        藍染半纏・印半纏のオーダーを承っております。
                                        しています。祭礼・職人・店舗用等、1枚から
                                        ご注文承ります。
                                    </p>
                                    <a href='http://www.kondo-some.co.jp/lineup/hanten.html'>
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                            </div>
                             <div>
                                <article>
                                    <h2>国旗/社旗/安全旗/会旗/各種旗</h2>
                                    <a href="http://www.kondo-some.co.jp/lineup/etc.html">
                                        <img src={Product_04} alt='Product_04' />
                                    </a>
                                    <p>
                                        社旗や団旗、そして様々な組織の旗を丁寧に作らさせていただきます。
                                    </p>
                                    <a href="http://www.kondo-some.co.jp/lineup/etc.html">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>帆前掛け/風呂敷</h2>
                                    <a href="http://www.kondo-some.co.jp/lineup/kaiki.html">
                                        <img src={Product_05} alt='Product_05' />
                                    </a>
                                    <p>
                                        伝統ある団体、組織の旗をお作りいたします。
                                        ポールなどの付属品やフリンジなどの縫い付け
                                        も行っておりますのでお気軽にご相談ください。
                                    </p>
                                    <a href="http://www.kondo-some.co.jp/lineup/kaiki.html">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>のぼり</h2>
                                    <a href="http://www.kondo-some.co.jp/lineup/nobori.html">
                                        <img src={Product_06} alt='Product_06' />
                                    </a>
                                    <p>
                                        宣伝広告用ののぼりはもとより、神社のぼりなど
                                        祭礼用ののぼりの制作も行っております。お祭や
                                        セールなどで一枚から承っております。
                                    </p>
                                    <a href="http://www.kondo-some.co.jp/lineup/nobori.html">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                            </div>
                             <div>
                                <article>
                                    <h2>神社・仏閣用のぼり/幕</h2>
                                    <a href="http://www.kondo-some.co.jp/lineup/jinjya.html">
                                        <img src={Product_07} alt='Product_07' />
                                    </a>
                                    <p>
                                        本染めの伝統的な職人技は、由緒ある神社仏閣
                                        の本殿用の門幕、大のぼり、祭事用の幕などに
                                        もしっかりと馴染むものとなっております。
                                    </p>
                                    <a href="http://www.kondo-some.co.jp/lineup/jinjya.html">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>手ぬぐい/タオル他</h2>
                                    <a href="https://kondo.shop-pro.jp/">
                                        <img src={Product_08} alt='Product_08' />
                                    </a>
                                    <p>
                                        染を身近に感じていただくため、気軽にご使用
                                        いただける製品を数多くラインナップしております。
                                    </p>
                                    <a href="https://kondo.shop-pro.jp/">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                                <article>
                                    <h2>節句祝い/各種お祝い</h2>
                                    <img src={Product_09} alt='Product_09' />
                                    <p>
                                        藍染半纏・印半纏のオーダーを承っております。
                                        しています。祭礼・職人・店舗用等、1枚から
                                        ご注文承ります。
                                    </p>
                                    <a href="https://kondo.shop-pro.jp/">
                                        <h4>制作事例・ご注文方法はこちら</h4>
                                    </a>
                                </article>
                            </div>
                            <div className='product-onlineStore'>
                                <a href='http://kondo.shop-pro.jp/'>
                                    <img src={ContentsButton} alt='オンラインショップ' />
                                </a>
                            </div>
                        </section>
                    </main>
                    <ContactButton />
                    <KondoFooter />
                </motion.div>
            </div>
        </div>
    )
}
export default PageProduct;